import { render, staticRenderFns } from "./BibliographySearchResultsAuthorityTable.vue?vue&type=template&id=1d196f18&"
import script from "./BibliographySearchResultsAuthorityTable.vue?vue&type=script&lang=ts&"
export * from "./BibliographySearchResultsAuthorityTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports